import { get } from 'lodash'

/**
 * @typedef {import('@ggs/types').LinkField} LinkField
 */
/**
 * @typedef {Object} useLinkProps
 * @property {LinkField=} link
 * @property {String=} href
 */
/**
 * @return {function(*): {isInternal: boolean, isExternal: boolean, label: unknown, uri: *, isAssetLink: boolean}}
 */
export default function useLink() {
  /**
   * @param {useLinkProps} props
   * @return {{isInternal: boolean, isExternal: boolean, label: string, uri: string, isAssetLink: boolean}}
   */
  return (props) => {
    const { link, href = '' } = props
    const label = get(link, 'title', '')
    const uri = get(link, 'uri', href || '').replace('internal:', '')
    const isInternal = uri.indexOf('/') === 0
    const isExternal = uri.indexOf('http') === 0
    const isAssetLink = /\/assets\/|\/static\//.test(uri)

    return {
      isInternal,
      isExternal,
      uri: uri.replace(/\/\//g, '/').replace('http:/', 'http://').replace('https:/', 'https://'),
      label,
      isAssetLink,
    }
  }
}
